module.exports = __webpack_public_path__ + "1-es2015.26cda97f6ab85aa48335.worker.js"